<template>
  <div class="gittbag">
    <div class="wrap" v-if='!defaultstate'>
    <div class="tab">
      <div class="item" :class="active==1?'active':''" @click="tabselect(1)">
        <span>待领取</span>
      </div>
      <div class="item" :class="active==2?'active':''" @click="tabselect(2)">
        <span>已领取</span>
      </div>
    </div>
      <div class="content" v-if="active == 1">
        <div class="nonum" v-if='ptgift.length==0&&timegift.length==0&czgift.length==0'>
          <img src="../assets/img/nonum@2x.png" alt="">
          <p>暂无数据</p>
        </div>
        <div class="giftwrap" v-if="ptgift.length">
          <span class="gifttip">普通礼包</span>
          <div v-for="item in ptgift" :key="item.id" class="content_item_wrap" @click="opendefaut(item)">
           <div class="content_item">
            <div class="contenttext">
            <p class="titlefont">{{item.giftName}}</p>
            </div>
            <div class="giftcontent">
              <p>{{item.giftContent}}</p>
            </div>
          <div class="lqbtn giftbtn" @click.stop="lingqu(item)" :class="item.resetCount>0?'':'nomore'">
            {{item.resetCount>0?'领取':'已抢光'}}
          </div>
          <p class="shengyu">剩余{{parseInt(item.resetCount/item.giftCount*100)}}%  </p>
          </div>
           <!-- <div class="outssice" v-if='active==2'>
            <p class="timecontent">有效期：{{item.endTime|formatDate}}</p>
            <p class="copynum">礼包码：{{item.giftCode}}</p>
          </div> -->
        </div>
        </div>
        <div class="giftwrap" v-if="timegift.length">
          <span class="gifttip">限时礼包</span>
          <div v-for="item in timegift" :key="item.id" class="content_item_wrap" @click="opendefaut(item)">
           <div class="content_item">
            <div class="contenttext">
            <p class="titlefont">{{item.giftName}}</p>
            </div>
            <div class="giftcontent">
              <p>{{item.giftContent}}</p>
             </div>
          <div class="lqbtn giftbtn" @click.stop="lingqu(item)" :class="item.resetCount>0?'':'nomore'">
            {{item.resetCount>0?'领取':'已抢光'}}
          </div>
          <p class="shengyu">剩余{{parseInt(item.resetCount/item.giftCount*100)}}%  {{item.activeEndTime|shengyuTime}}</p>
          </div>
           <!-- <div class="outssice" v-if='active==2'>
            <p class="timecontent">有效期：{{item.endTime|formatDate}}</p>
            <p class="copynum">礼包码：{{item.giftCode}}</p>
          </div> -->
        </div>
        </div>
        <div class="giftwrap" v-if="czgift.length">
          <span class="gifttip">充值礼包</span>
          <div v-for="item in czgift" :key="item.id" class="content_item_wrap" @click="opendefaut(item)">
           <div class="content_item">
            <div class="contenttext">
            <p class="titlefont">{{item.giftName}}</p>
            </div>
            <div class="giftcontent">
              <p>{{item.giftContent}}</p>
              </div>
          <div class="lqbtn giftbtn" @click.stop="lingqu(item)" :class="item.resetCount>0?'':'nomore'">
            {{item.resetCount>0?'领取':'已抢光'}}
          </div>
          <p class="shengyu">剩余{{parseInt(item.resetCount/item.giftCount*100)}}%</p>
          </div>
           <!-- <div class="outssice" v-if='active==2'>
            <p class="timecontent">有效期：{{item.endTime|formatDate}}</p>
            <p class="copynum">礼包码：{{item.giftCode}}</p>
          </div> -->
        </div>
        </div>
      </div> 
      <div class="content" v-else>
        <div class="nonum" v-if='list.length==0'>
          <img src="../assets/img/nonum@2x.png" alt="">
          <p>暂无数据</p>
        </div>
        <div v-for="item in list" :key="item.id" class="content_item_wrap">
           <div class="content_item">
            <div class="contenttext">
            <div class="titlefont">{{item.giftName}}</div>
            <div class="gifttime">有效期至{{item.endTime|formatDate}}</div>
            </div>
            <div class="giftcontent">
              <p>
                {{item.giftContent}}
              </p>
            </div>
          </div>
           <div class="outssice" v-if='active==2'>
            <p class="copynum over_more">礼包码：{{item.giftCode}}</p>
            <div class="lqbtn giftbtn" @click.stop="copy(item.giftCode)">
            <!-- {{active==1?'领取':'复制'}} -->
            复制
          </div>
          </div>
        </div>
        <div class="copycontent" ref="copycontent">
            {{copytext}}
        </div>
      </div> 
      <!-- <div class="oldcontent" v-if="active==2">
        <div class="content_item" v-for="item in list" :key="item.id">
          <div class="contenttext">
          <p class="titlefont">{{item.giftName}}</p>
          <p class="giftcontent">{{item.giftContent}}</p>
          </div>
        <div class="lqbtn giftbtn" @click="lingqu(item)">
          复制
        </div>
        </div>
      </div> -->
    </div>
    <div class="detailwrap" v-else>
       <div class="topnav">
        <img src="../assets/img/fh-icon@2x.png" alt="" @click="defaultstate=false">
        <span>
        礼包详情
        </span>
      </div>
      <div>
        <div class="giftdetail">
          <p class="title">{{item.giftName}}</p>
          <p class="giftcontent">{{item.giftContent}}</p>
          <p class="giftnum" v-if="item.resetCount">剩余{{parseInt(item.resetCount/item.giftCount*100)}}%</p>
        </div>
        <div v-if='item.activeStartTime&&item.activeEndTime&&item.giftType==3'>
          <p class="detaillab">
            限时领取
          </p>
          <p class="detailmes">
            {{item.activeStartTime|formatDate}}至{{item.activeEndTime|formatDate}}
          </p>
        </div>
        <div v-if="item.payMoney">
          <p class="detaillab">领取条件</p>
          <p class="detailmes" v-if="item.payUseStatus==1">{{item.payStartTime|formatDate}}至{{item.payEndTime|formatDate}}游戏内累计消费达到{{item.payMoney/100}}元（游戏内价格）可领取</p>
          <p class="detailmes" v-else>游戏内累计消费达到{{item.payMoney/100}}元（游戏内价格）可领取</p>
        </div>
        <div>
          <p class="detaillab">礼包有效期</p>
          <p class="detailmes">
             {{item.startTime|formatDate}}至{{item.endTime|formatDate}}
          </p>
        </div>
      </div>
          <div class="usebtn">
          <!-- <div class="btn" >
              领取
          </div> -->
          <div class="copy" v-if="item.giftCode">
            <p class="copygiftnum over_more">礼包码：{{item.giftCode}}</p>
            <div class="copybtn" @click="copy(item.giftCode)">
              复制
            </div>
          </div>
          <div class="copy lingqu" v-else-if="item.resetCount>0" @click="lingqu(item)">
            领取
          </div>
          <div class="copy middle" v-else>
             已抢光
          </div>
          </div>
    </div>
      <div class="copycontent" ref="copycontent">
        {{copytext}}
      </div>
  </div>
</template>
<script>
// @ is an alias to /src
import md5 from 'js-md5';
import {getgift,getgifted,lingqugift} from '@/api/giftbag'
export default {
   data(){
     return {
       active:1,
       list:[],
       form:{
        userId:'',
        productId:'',
        channelId:'',
        osType:'',
      },
      item:{},
      lingqustate:false,
      copytext:'',
      defaultstate:false,
      ptgift:[],
      timegift:[],
      czgift:[]
     }
   },
   created(){
     if(this.$route.query.osType){
      this.form.osType = this.$route.query.osType
      this.form.channelId = this.$route.query.channelId
      this.form.productId = this.$route.query.productId
      this.form.userId = this.$route.query.userId
     }
    //  window.location.href = 'http://192.168.0.45:8080/vochers'
    // this.$router.push('/other')
     getgift(this.form).then(res=>{
      //  console.log(res)
      let arr = []
      let arr2 =[]
      let arr3 = []
      if(res.data.code == 200){
        try{
         res.data.data.gifts.forEach(element => {
           if(element.giftType == 1){
             arr.push(element)
           }else if(element.giftType == 2){
             arr2.push(element)
           }else if(element.giftType==3){
             arr3.push(element)
           } 
         });
         this.ptgift = arr
         this.czgift = arr2
         this.timegift = arr3
        }catch(error){
          this.ptgift = []
          this.czgift = []
          this.timegift = []
          console.log(error)
        }
        // this.list = res.data.data.gifts

      }
     })
   },
   filters:{
        formatDate(data) {
          if(!data){return '-'}
          //时间戳是整数，否则要parseInt转换
          var time = new Date(data*1000); // 需要使用Date格式进行日期转化，若是时间戳、字符串时间，需要通过new Date(..)转化
          var y = time.getFullYear();
          var m = time.getMonth()+1;
          var d = time.getDate();
          var h = time.getHours();
          var mm = time.getMinutes();
          var s = time.getSeconds();
          // return y+'-'+isZero(m)+'-'+isZero(d)+' '+isZero(h)+':'+isZero(mm)+':'+isZero(s);
          return y+'.'+isZero(m)+'.'+isZero(d);
          function isZero(m){
          return m<10?'0'+m:m
        }
    },
    shengyuTime(val){
          var date = Date.now()/1000;
          var dates = Math.ceil((val - date)/(60*60*24));    
          if(dates>1){
            return '剩余'+dates+'天';   
          }else{
            return '今天结束'
          }
    }
   },
   methods:{
     opendefaut(item){
       this.item = item
       this.defaultstate = true
     },
     lingqu(item){
         const that = this
         if(item.receiveGiftMethods){
            if(this.form.osType == 1){
              try{
                window.SDK.openapp(5,1,item.productId,'','')
              }catch(error){
                //兼容老版本问题  如果没有找到跳转APP方法  就直接通过接口领取
                var form = {
                    userId:this.form.userId,
                    giftId:item.id,
                    osType:this.form.osType,
                    productId:this.form.productId,
                    sign:''
                    }
                    var str =this.form.productId+''+this.form.userId+''+item.id+''+this.form.osType+'5aSn6Iej5ri45oiP'
                    form.sign = md5(str)
                    lingqugift(form).then(res=>{
                    if(res.data.code ==200 ){
                      this.tabselect(1)
                      if(this.form.osType == 1){
                        try{
                          window.SDK.getgiftsuccess(res.data.data);
                          this.$set(item,'giftCode',res.data.data)
                        }catch(error){
                          console.error(error)
                        }
                      }else if(this.form.osType == 2){
                        try{
                          window.webkit.messageHandlers.getgiftsuccess.postMessage(res.data.data);
                          this.$set(item,'giftCode',res.data.data)
                        }catch(error){
                          console.error(error)
                        }
                      }
                      }
                    })
              }
            }else if(this.form.osType == 2){
              // try{
              //   const jsonstr2 = JSON.stringify({packName:this.pagebag,pageurl:this.pageurl+'&productId='+item.productId,productId:item.productId})
              //   window.webkit.messageHandlers.godownpage.postMessage(jsonstr2);
              // }catch{
              //   console.log(error)
              // }
            }
         }else{
          var form = {
          userId:this.form.userId,
          giftId:item.id,
          osType:this.form.osType,
          productId:this.form.productId,
          sign:''
          }
          var str =this.form.productId+''+this.form.userId+''+item.id+''+this.form.osType+'5aSn6Iej5ri45oiP'
            form.sign = md5(str)
            lingqugift(form).then(res=>{
            if(res.data.code ==200 ){
              if(this.form.osType == 1){
                try{
                  window.SDK.getgiftsuccess(res.data.data);
                  this.$set(item,'giftCode',res.data.data)
                }catch{
                }
              }else if(this.form.osType == 2){
                try{
                  window.webkit.messageHandlers.getgiftsuccess.postMessage(res.data.data);
                  this.$set(item,'giftCode',res.data.data)
                }catch{
                }
              }
              this.tabselect(1)
              }
            })
          }
      //  couponGiftKey ：5aSn6Iej5ri45oiP
     },
     copy(str){
       this.copytext = str
          setTimeout(() => {
            if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {//区分iPhone设备
            window.getSelection().removeAllRanges();//这段代码必须放在前面否则无效
            var Url2= this.$refs.copycontent//要复制文字的节点
            var range = document.createRange();
            // 选中需要复制的节点
            range.selectNode(Url2);
            // 执行选中元素
            window.getSelection().addRange(range);
            // 执行 copy 操作
            document.execCommand('copy');
            this.$Message.show('复制成功')
            // 移除选中的元素
            window.getSelection().removeAllRanges();
            }else{
            var text = this.$refs.copycontent.innerText;
            const textarea = document.createElement("textarea") ;
            textarea.style.position = 'fixed' ;
            textarea.style.top = 0 ;
            textarea.style.left = 0 ;
            textarea.style.border = 'none' ;
            textarea.style.outline = 'none' ;
            textarea.style.resize = 'none';
            textarea.style.background = 'transparent' ;
            textarea.style.color = 'transparent';
            textarea.value = text ;// 修改文本框的内容
            document.body.appendChild(textarea);
            textarea.select()// 选中文本
          try { document.execCommand('copy') 
            this.$Message.show('复制成功')
          } catch (err) { 
              console.log(err)
              }
            document.body.removeChild(textarea)
          }
          }, 0);
     },
     tabselect(num){
       let arr = []
       let arr2 =[]
       let arr3 = []
       if(num == 1){
         getgift(this.form).then(res=>{
           if(res.data.code== 200){
             try{
            res.data.data.gifts.forEach(element => {
              if(element.giftType == 1){
                arr.push(element)
              }else if(element.giftType == 2){
                arr2.push(element)
              }else if(element.giftType==3){
                arr3.push(element)
              } 
            });
            this.ptgift = arr
            this.czgift = arr2
            this.timegift = arr3
            }catch(error){
              this.ptgift = []              
              this.czgift = []
              this.timegift = []
              console.log(error)
            }
              }
              this.active = num
            })
          }else{
            getgifted(this.form).then(res=>{
              if(res.data.code== 200){
                this.active = num
                this.list = res.data.data
              }
            })
       }
     },
     backnative(){

     }
   }
}
</script>
<style lang="less" scoped>
  .gittbag{
    font-size: 0.7rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgb(247,248,249);
    // padding-bottom: 2.25rem;
    .content{
      width: 100%;
      height: 100%;
      background: rgb(247,248,249);
      padding:2.25rem 0.5rem 0.5rem;
      overflow-y: auto;
      position: relative;
      .giftwrap{
      background: #fff;
      position: relative;
      border-radius: 0.4rem;
      overflow: hidden;
      margin-top: 0.53rem;
      padding: 1.25rem 0.75rem 0;
      .gifttip{
        width: 3.75rem;
        height: 1.25rem;
        background: linear-gradient(90deg, #FBB00E, #F5CC40);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 20;
        line-height: 1.25rem;
        text-align: center;
        font-size: 0.65rem;
        color: #fff;
        border-bottom-right-radius: 0.3rem;
      }
      .content_item_wrap{
        margin-top: 0;
        padding-left: 0;
        padding-right: 0;
        border-bottom: 1px solid #E6E6E7;
        border-radius: 0;
        .content_item{
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          padding: 3px 0;
          .giftcontent{
            background: none;
            // width: 8.45rem;
            flex: 1;
            padding: 0;
            margin-bottom: 0.2rem;
            margin-right: 0.63rem;
            p{
              overflow: hidden;
              display: -webkit-box;
              text-overflow: ellipsis;
              -webkit-line-clamp: 2;  /*要显示的行数*/
              -webkit-box-orient: vertical;
            }
          }
          .lqbtn{
            margin-left: 0;
            font-weight: 500;
            color: #070C2D;
            &.nomore{
              background: #d6d6d6;
              color: #fff;
            }
          }
          .shengyu{
            width: 100%;
            font-size: 0.55rem;
            color: #F29A00;
            line-height: 0.7rem;
            word-spacing: 0.3rem;
          }
        }
        &:last-child{
          border-bottom:none;
        }
      }
    }
      .content_item_wrap{
        background: #fff;
        border-radius: 0.4rem;
        padding: 0.595rem 0.75rem;
        margin-top: 0.6rem;
      .content_item{
        width: 100%;
        overflow: hidden;
        padding-bottom: 0;
        padding-top: 3px;
        .contenttext{
          width: 100%;
          display: flex;
          justify-content: space-between;
        }
        .lqbtn{
          width:2.5rem;
          height:1.15rem;
          background:rgba(245,204,64,1);
          border-radius:1rem;
          margin-left: 1.13rem;
          text-align: center;
          line-height: 1.15rem;
          align-self: center;
          flex-shrink: 0;
        }
        .titlefont{
          height: 0.69rem;
          line-height: 0.68rem;
          word-spacing: normal;
          font-weight: bold;
        }
        .giftcontent{
          width: 100%;
          line-height: 0.8rem;
          margin-top: 0.2rem;
          background: #F6F6F6;
          padding: 0.55rem;
          border-radius: 0.4rem;
          color: #666666;
          p{
            display: inline-block;
            width: 100%;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;  /*要显示的行数*/
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
      }
      .gifttime{
        font-size: 0.55rem;
        color:#999999;
      }
      .outssice{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: start;
        .timecontent{
          padding-bottom: 0.55rem;
          border-bottom: 1px dashed #E19839;
        }
        .lqbtn{
          width:2.5rem;
          height:1.15rem;
          background:rgba(245,204,64,1);
          border-radius:1rem;
          margin-left: 1.13rem;
          text-align: center;
          line-height: 1.15rem;
          align-self: center;
          flex-shrink: 0;
          color: #070C2D;
          font-size: 0.6rem;
        }
        .copynum{
          width: 9.53rem;
          height: 1.58rem;
          line-height: 1.58rem;
          color: #F29A00;
        }
      }
    }
      }
.topnav{
        width: 100%;
        height: 2.25rem;
        background:#fff;
        text-align: center;
        line-height: 2.25rem;
        font-size:0.8rem;
        font-family:PingFang SC;
        color:rgba(17,17,17,1);
        position: relative;
        border-bottom: 0.28rem solid #F7F8F9;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        img{
          height: 0.75rem;
          display: block;
          position: absolute;
          left: 0.75rem;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }
      .copycontent{
        position: absolute;
        left: -1000px;
      }
  }
  .tab{
    height: 2.25rem;
    width: 100%;
    font-size: 0.7rem;
    line-height: 2.25rem;
    background: #fff;
    // box-shadow:0 1px 0 0 rgba(210,210,210,1);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    .item{
      width: 50%;
      float: left;
      text-align: center;
      color: #666666;
    }
    .item.active{
      color: #111111;
      span{
        position: relative;
        &::after{
        content: '';
        width: 100%;
        height: 0.2rem;
        background: #F1B82E;
        position: absolute;
        left: 0;
        right: 0;
        top: 1.35rem;
        margin: auto;
        border-radius: 0.1rem 0.1rem 0 0;
        z-index: 10;
        }
      }
    }
  }
    .usebtn{
    width: 100%;
    height: 2.45rem;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0 0.75rem;
    .btn{
      width: 12.45rem;
      height: 1.75rem;
      line-height: 1.75rem;
      text-align: center;
      background: #F5CB3F;
      border-radius:14px;
      margin:0.35rem auto;
      color: #fff;
      padding-left: 0.45rem;
    }  
    .copy{
     display: flex;
     border-radius: 2rem;
     background: #F4F4F4;
     align-items: center;
     height: 2.21rem;
     padding-left: 0.45rem;
     &.lingqu{
       font-size: 0.75rem;
       justify-content: center;
       color: #000;
       background: #F5CC40;
     }
     &.middle{
       font-size: 0.75rem;
       justify-content: center;
       color: #fff;
       background: #D6D6D6;
     }
     .copygiftnum{
       flex: 1;
       font-size: 0.55rem;
       color: #727272;
     }
     .copybtn{
       width: 3.5rem;
       height: 1.9rem;
       background: #F5CC40;
       border-radius: 2rem;
       text-align: center;
       line-height: 1.9rem;
       color: #1F1F1F;
       font-size: 0.75rem;
       margin-right: 0.2rem;
     }
   }
  }

   .detailwrap{
     padding: 3rem 0.75rem;
     background: #fff;
     height: 100%;
     overflow-y: auto;
     padding-bottom: 2.45rem;
     .giftdetail{
      width: 100%;
      // height: 5.75rem;
      background: linear-gradient(-90deg, #F5CC40, #FDE560);
      border-radius: 0.4rem;
      padding: 0.6rem;
      box-sizing: border-box;
      margin-bottom: 0.8rem;
      .title{
        font-size: 0.95rem;
        font-weight: bold;
        color: #3E3244;
        margin-bottom: 0.28rem;
      }
      .giftcontent{
        font-size: 0.65rem;
        color: #5C4700;
        margin-bottom: 0.18rem;
      }
      .giftnum{
        font-size: 0.65rem;
        color: #000;
      }
    }
    .detaillab{
      font-size: 0.75rem;
      color: #666666;
      margin-bottom: 0.38rem;
    }
    .detaillab::before{
      content: '';
      display: inline-block;
      width: 0.56rem;
      height: 0.56rem;
      background: #F8C444;
      border: #000 solid 1px;
      border-radius: 50%;
      margin-right: 0.45rem;
    }
    .detailmes{
      font-size: 0.65rem;
      color: #9A9A9A;
      margin-bottom: 0.73rem;
    }
   }
</style>
